import { render, staticRenderFns } from "./FspAcknowledgeForm.vue?vue&type=template&id=35b206fa&"
import script from "./FspAcknowledgeForm.vue?vue&type=script&lang=js&"
export * from "./FspAcknowledgeForm.vue?vue&type=script&lang=js&"
import style0 from "./FspAcknowledgeForm.vue?vue&type=style&index=0&id=35b206fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports